import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-counter',
  imports: [SharedModule],
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss'
})
export class CounterComponent {
  @Input() orgId!: string;
  form: FormGroup;
  loading = false;

  initialLoading = true;

  isCounterAdded = false;


  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      counter_id: [null],
      registration_id: [null],
      registration_id_prefix: [null],
      registration_id_length: [null],
      application_number: [null],
      application_number_prefix: [null],
      application_number_length: [null],
      ticket_id: [null],
      ticket_id_prefix: [null],
      ticket_id_length: [null]
    });
  }

  ngOnInit() {
    this.getOrgCounter();
  }

  getOrgCounter() {

    const body = {
      "where": {
        "organization_id": this.orgId
      }
    }

    this.orgService.getCounterById(body).subscribe({
      next: (res) => {
        this.initialLoading = false;
        if (res) {
          this.isCounterAdded = true;

          this.form.patchValue({
            counter_id: res.counter_id,
            registration_id: res.registration_id,
            registration_id_prefix: res.registration_id_prefix,
            registration_id_length: res.registration_id_length,
            application_number: res.application_number,
            application_number_prefix: res.application_number_prefix,
            application_number_length: res.application_number_length,
            ticket_id: res.ticket_id,
            ticket_id_prefix: res.ticket_id_prefix,
            ticket_id_length: res.ticket_id_length
          });
        }
      },
      error: (err) => {
        this.initialLoading = false;
      }
    });
  }



  onSubmit() {
    if(this.isCounterAdded) {
      this.updateCounter();
    }else{
      this.createCounter();
    }
  }

  updateCounter() {
    const body = {
      "organization_id": this.orgId,
      "counter_id": this.form.value.counter_id,
      "registration_id": this.form.value.registration_id,
      "registration_id_prefix": this.form.value.registration_id_prefix,
      "registration_id_length": this.form.value.registration_id_length,
      "application_number": this.form.value.application_number,
      "application_number_prefix": this.form.value.application_number_prefix,
      "application_number_length": this.form.value.application_number_length,
      "ticket_id": this.form.value.ticket_id,
      "ticket_id_prefix": this.form.value.ticket_id_prefix,
      "ticket_id_length": this.form.value.ticket_id_length
    }
    this.loading = true;
    this.orgService.updateCounter(body).subscribe({
      next: (res) => {
        console.log(res);
        this.isCounterAdded = true;
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Counter updated successfully'
        });
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }

  createCounter() {
    const body = {
      "organization_id": this.orgId,
      "registration_id": this.form.value.registration_id,
      "registration_id_prefix": this.form.value.registration_id_prefix,
      "registration_id_length": this.form.value.registration_id_length,
      "application_number": this.form.value.application_number,
      "application_number_prefix": this.form.value.application_number_prefix,
      "application_number_length": this.form.value.application_number_length,
      "ticket_id": this.form.value.ticket_id,
      "ticket_id_prefix": this.form.value.ticket_id_prefix,
      "ticket_id_length": this.form.value.ticket_id_length
    }
    this.loading = true;
    this.orgService.createCounter(body).subscribe({
      next: (res) => {
        console.log(res);
        this.isCounterAdded = true;
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Counter created successfully'
        });
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }

}
